import { EDIT_CONFIRM } from '../../constant';

const initialState = false;

const editConfirm = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_CONFIRM:
      return action.payload;
    default:
      return state;
  }
};

export default editConfirm;
